
import { Component, Ref, Vue, Watch, Provide } from 'vue-property-decorator'
import { debounce } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

import WelcomeMsg from '@/components/welcome-msg.vue'
import HumanMsg from '@/components/human-msg.vue'
import RobotMsg from '@/components/robot-msg.vue'
import UserMsg from '@/components/user-msg.vue'
import UserImg from '@/components/user-img.vue'
import PageFooter from '@/components/page-footer.vue'
import TopAsk from '@/components/top-ask.vue'
import ImgPreview from '@/components/img-preview.vue'
import EmojiPicker from '@/components/emoji-picker.vue'
import RejectManual from '@/components/reject-manual.vue'
import SilenceQuestion from '@/components/silence-question.vue'
import UserVoice from '@/components/user-voice.vue'
import End from '@/components/end.vue'
import AdPanel from '@/components/ad-panel.vue'
import VideoPlayer from '@/components/video-player.vue'
import ManualBtn from '@/components/manual-btn.vue'
import HumanImg from '@/components/human-img.vue'
import Satisfaction from '@/components/satisfaction.vue'

import { isEmpty, getVal, getUrlParam, parseJson } from '@/utils/helpers'

import * as Common from '@/api/common'
import { IMsgItem } from '@/interface'
import { AnswerType, MsgType, ChatStatus, ResCode, ChatType } from '@/utils/const'
import Bus from '@/utils/bus'
import { AppModule } from '@/store/modules/app'
import CountDown from '@/utils/count-down'
import { ChatModule } from '@/store/modules/chat'
import DLog from '@/utils/log'

DLog.enable(window.config.debug)

@Component({
  components: {
    WelcomeMsg,
    RobotMsg,
    UserMsg,
    UserImg,
    PageFooter,
    TopAsk,
    ImgPreview,
    EmojiPicker,
    RejectManual,
    SilenceQuestion,
    UserVoice,
    End,
    AdPanel,
    VideoPlayer,
    ManualBtn,
    HumanMsg,
    HumanImg,
    Satisfaction
  }
})
export default class Index extends Vue {
  @Ref('imgPreview')
  readonly imgPreview!: ImgPreview

  @Ref('pageFooter')
  readonly pagerFooter!: PageFooter

  @Ref('manulBtn')
  readonly manulBtn!: ManualBtn

  readonly MsgType = MsgType

  private scrollAuto = debounce(this.scrollIntoView, 200)

  config = window.config

  showTts = !isEmpty(window.config.ttsList)

  showLoading = true
  showWanting = false
  
  // 会话当前状态
  chatStatus = ChatStatus.NotInit

  emojiVisible = false
  silenceCounting = true

  robotImg = ''
  // 渠道id
  channelId = ''
  // 用户id
  userId = ''
  // talkId
  talkId = ''
  // 初始化函数
  inparams = {}

  hotList: Array<any> = []
  @Provide()
  messageList: Array<IMsgItem> = []
  // 悬浮意图
  wantingList: Array<any> = []
  silenceTip: any = ''
  silenceList: Array<any> = []
  
  timer: number | null = null
  time: number | null = null

  silenceCountDown: any = null

  robotTitle: any = ''
  attachments: any = []
  contentHtml: any = ''
  primaryColor: any = '#1989fa'
  botInfo: any = {}

  // 机器人名称
  get robotName() {
    return AppModule.robotName
  }

  get chatType() {
    return ChatModule.chatType
  }

  get showWantingWrapper() {
    if (this.showWanting && this.wantingList.length) {
      return true
    }

    if (this.showIconPanel) {
      return true
    }

    return false
  }

  get showIconPanel() {
    return this.showEmoji
  }
  
  get showEmoji () {
    return window.config.showEmoji
  }

  get spinning() {
    return AppModule.spinning
  }

  get tip() {
    return AppModule.tip
  }

  async mounted () {
    const userId = this.getUserId()
    this.userId = userId
    AppModule.setUserId(userId)
    
    this.init()
    
    Bus.$on('requestAnswer', this.requestAnswer)
  }

  beforeDestroy() {
    Bus.$off('requestAnswer')
  }

  activated () {
    this.scrollAuto()
  }

  @Watch('messageList')
  onMessageListChange () {
    this.$nextTick(() => {
      this.scrollAuto()
    })
  }

  scrollIntoView () {
    const vm:any = this.$refs.mainBody
    if (vm) {
      vm.scrollTop = vm.scrollHeight
    }
  }

  getUserId (): any {
    return getUrlParam('userId') || Math.ceil(Math.random() * 100000000) + '_random'
  }

  init () {
    return this.getChannelId().then((channelId: any) => {
      this.channelId = channelId
      // 入参近7天的时间
      const yyyymmdd = 'YYYY-MM-DD'
      const beginTime = moment().subtract(7, 'days').format(yyyymmdd)
      const endTime = moment().format(yyyymmdd)
      return Promise.all([
        Common.getRobotConfig(channelId), 
        Common.getTopHot(channelId, beginTime, endTime, 50)
      ])
    }).then(([botInfo, topHotList]: any[]) => {
      this.botInfo = botInfo

      const time = botInfo.time || 0
      this.time = time
      // 热门推荐
      const topHot = topHotList.map((obj: any) => obj.knowledgeName)
      const recommond = parseJson(botInfo.recommond, [])
      this.hotList = isEmpty(recommond) ? topHot : recommond
      // 悬浮意图
      this.wantingList = getVal(botInfo, 'suspensionKnowledge', [])
      this.showWanting = getVal(botInfo, 'suspensionFlag', 1) === 0
      // 设置机器人头像
      this.robotImg = getVal(botInfo, 'robotImage.url', '')

      let silence = getVal(botInfo, 'slience', '[]')
      this.silenceList = parseJson(silence)

      const silenceTip = getVal(botInfo, 'slienceReminder', '')
      this.silenceTip = isEmpty(silenceTip) ? this.$t('timeOutTips') : silenceTip

      // 设置机器人相关信息
      const robotName = getVal(botInfo, 'robotNickname', this.$t('defaultRobot'))
      document.title = robotName
      AppModule.setRobotName(robotName)

      // 设置网页icon
      const link = document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = getVal(botInfo, 'robotImage.url', '')
      document.getElementsByTagName('head')[0].appendChild(link)

      //
      this.robotTitle = getVal(botInfo, 'title', '回答问题并提供对应的解决方案')

      // 设置主体色
      const primaryColor = document.documentElement.style.getPropertyValue('--primary-color')
      const color = getVal(botInfo, 'color', primaryColor)
      document.documentElement.style.setProperty(`--primary-color`, color)

      //
      this.primaryColor = color

      this.silenceCountDown = new CountDown(time, window.config.tipsBefore)

      // 广告轮播图
      this.attachments = getVal(botInfo, 'attachments', [])
      this.contentHtml = getVal(botInfo, 'contentHtml', '')

      this.showLoading = false

      return Common.initConsult(this.channelId, this.userId)
    }).then(res => {
      // 重新倒计时进行会话结束
      this.countdown()

      this.chatStatus = ChatStatus.Inited

      const talkId = getVal(res, 'talkId', '')
      this.talkId = talkId
      AppModule.setTalkId(talkId)

      this.inparams = getVal(res, 'inparams', {})

      const welcome = getVal(res, 'welcoming', this.$t('welcome'))
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Time,
        content: moment().format('YYYY-MM-DD HH:mm:ss')
      })

      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Welcome,
        content: welcome
      })

      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.HotList,
        content: this.hotList
      })
    })
  }

  initConsult () {
    return Common.initConsult(this.channelId, this.userId).then(res => {
      // 重新倒计时进行会话结束
      this.countdown()

      this.chatStatus = ChatStatus.Inited
      this.talkId = getVal(res, 'talkId', '')
      this.inparams = getVal(res, 'inparams', {})

      const welcome = getVal(res, 'welcoming', this.$t('welcome'))

      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Time,
        content: moment().format('YYYY-MM-DD HH:mm:ss')
      })

      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Welcome,
        content: welcome
      })

      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.HotList,
        content: this.hotList
      })
    })
  }

  beforeEnd() {
    if (this.chatType === ChatType.ToHuman) {
      this.$confirm({
        title: '确定离开？',
        content: '客服正在为您解答，请先不要断开，您是否确认离开。若离开再次返回，需要重新建立新的对话连接。',
        okText: '确定离开',
        onOk: () => {
          this.manulBtn.releaseChat()
          ChatModule.setChatType(ChatType.ToRobot)
          this.endChat()
        }
      })
    } else {
      ChatModule.setChatType(ChatType.ToRobot)
      this.endChat()
    }
  }

  endChat (content?: String) {
    if (this.chatStatus === ChatStatus.Ended) {
      return
    }
    
    this.chatStatus = ChatStatus.Ended
    
    // 清除沉默提示定时器
    this.silenceCountDown && this.silenceCountDown.clearTimer()
    // 清除会话结束定时器
    this.clearTimeout()

    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.End,
      content: content || this.$t('callEnd')
    })

    Common.exitConsult({
      channelId: this.channelId,
      talkId: this.talkId,
      userId: this.userId,
      inparams: this.inparams
    })
  }

  /**
   * 清楚会话结束定时器
   */
  clearTimeout() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }

  /**
   * 进行倒计时结束会话
   */
  countdown () {
    this.clearTimeout()

    if (this.time) {
      this.silenceCountDown.start(() => {
        // 人机对话时出现静默提示语
        if (this.chatType === ChatType.ToRobot) {
          if (this.chatStatus === ChatStatus.Inited) {
            this.messageList.push({
              uuid: uuidv4(),
              type: MsgType.Silence,
              content: ''
            })
          }
        }
      })

      this.timer = setTimeout(() => {
        // 人机对话时超时结束对话
        if (this.chatType === ChatType.ToRobot) {
          const conent = this.$t('quitTips')
          this.endChat(conent as string)
        }
      }, this.time * 1000)
    }
  }

  getChannelId () {
    const promise = new Promise((resolve, reject) => {
      const channelId = getUrlParam('channelId')
      if (!isEmpty(channelId)) {
        const _channelId = window.config.channels[channelId as string]
        resolve(_channelId)
      } else {
        Common.queryChannelInfo().then(res => {
          const channelIds = getVal(res, 'channelIds', [])
          if (!isEmpty(channelIds)) {
            resolve(channelIds[0].channelId)
          } else {
            resolve(null)
          }
        }).catch(() => {
          resolve(null)
        })
      }
    })

    return promise
  }
  
  onAskSelect (text: string) {
    this.emojiVisible = false
    
    if (this.chatStatus === ChatStatus.Inited) {
      // 重新倒计时进行会话结束
      this.countdown()
      this.requestAnswer(text)
    } else {
      this.initConsult().then(res => {
        this.requestAnswer(text)
      })
    }
  }


  /**
   * @params question:问题
   * @params flag: 是否展示问题消息
   */
  requestAnswer (question: string, flag = true) {
    if (this.chatType === ChatType.ToRobot) {
      this.requestAnswerForRobot(question, flag)
    } else {
      this.requestAnswerForHuman(question, flag)
    }
  }

  requestAnswerForRobot(question: string, flag = true) {
    this.pagerFooter.searchContent = ''

    if (isEmpty(question)) {
      return
    }

    const params = {
      channelId: this.channelId,
      userId: this.userId,
      question: question,
      talkId: this.talkId
    }
    Common.sendQuestion(params).then((res: any) => {
      if (flag) {
        // 展示时间
        this.messageList.push({
          uuid: uuidv4(),
          type: MsgType.Time,
          content: moment().format('YYYY-MM-DD HH:mm:ss')
        })
        // 展示问题
        this.messageList.push({
          uuid: uuidv4(),
          type: MsgType.UserMsg,
          content: question
        })
      }

      const { contentType } = res
      switch (contentType) {
        // 有答案
        case '1':
          this.handleA(res)
          break
        // 无答案取推荐问
        case '2':
          this.handleB(res)
          break
        // 无答案，取会话资源
        case '3':
          this.handleC(res)
          break
        default:
          break;
      }
    }).catch(err => {
      const { code } = err
      switch (code) {
        // 会话超时
        case ResCode.E10007:
          this.sessionTimeOut(question)
          break
        // 转人工意图转人工
        case ResCode.E60001:
          this.manualHandle(err, question, flag)
          break
        // 五次拒识转人工
        case ResCode.E60002:
          this.rejectToManual(err, question, flag)
          break
        case ResCode.E60003:
          this.rejectToManual(err, question, flag)
          break
        default:
          break
      }
    })
  }

  requestAnswerForHuman(question: string, flag = true) {
    this.pagerFooter.searchContent = ''

    if (isEmpty(question)) {
      return
    }

    // 展示时间
    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.Time,
      content: moment().format('YYYY-MM-DD HH:mm:ss')
    })
    // 展示问题
    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.UserMsg,
      content: question
    })

    this.manulBtn.sendText(question)
  }

  /**
   * 
   * @param obj 
   * @param showManual 是否展示转人工
   */
  handleA (obj: any, showManual = false) {
    const { moreStd } = obj

    if (moreStd) {
      const array = getVal(obj, 'answerItems', [])

      const promptGuide = getVal(obj, 'promptGuide', '')
      const questionStd = getVal(obj, 'questionStd', [])
      const linkIssue = questionStd.map((obj: any) => {
        return parseJson(obj)
      })
      array.push({
        contentType: AnswerType.LinkAnswer,
        promptGuide,
        linkIssue
      })
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.RobotMsg,
        content: array,
        commonInfo: {
          answerStamp: getVal(obj, 'answerStamp', ''),
          channelId: this.channelId,
          knowledgeId: getVal(obj, 'inAimcNet.matchKnowledgeId', ''),
          talkId: this.talkId
        },
        showFeedback: obj.satisfactionFlag === 0,
        showManual
      })
    } else {
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.RobotMsg,
        content: getVal(obj, 'answerItems', []),
        commonInfo: {
          answerStamp: getVal(obj, 'answerStamp', ''),
          channelId: this.channelId,
          knowledgeId: getVal(obj, 'inAimcNet.matchKnowledgeId', ''),
          talkId: this.talkId
        },
        showFeedback: obj.satisfactionFlag === 0,
        showManual
      })
    }
  }

  /**
   * 无答案取推荐问
   * @param obj
   * @param showManual 是否展示转人工
   */
  handleB (obj: any, showManual = false) {
    const promptText = getVal(obj, 'promptText', '')
    if (!isEmpty(promptText)) {
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.RobotMsg,
        content: [{
          contentType: AnswerType.Common,
          content: promptText
        }],
        showFeedback: obj.satisfactionFlag === 0,
        showManual
      })
    }

    const { moreStd } = obj
    if (moreStd) {
      const array = []
      const promptGuide = getVal(obj, 'promptGuide', '')
      const questionStd = getVal(obj, 'questionStd', [])
      const linkIssue = questionStd.map((obj: any) => {
        return parseJson(obj)
      })
      array.push({
        contentType: AnswerType.LinkAnswer,
        promptGuide,
        linkIssue
      })
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.RobotMsg,
        content: array,
        showFeedback: obj.satisfactionFlag === 0,
        showManual
      })
    }

  }

  /**
   * 
   * @param obj 
   * @param showManual 是否展示转人工
   */
  handleC (obj: any, showManual = false) {
    const dataList: any = []

    let content = getVal(obj, 'promptText', '')
    if (!isEmpty(content)) {
      dataList.push({
        contentType: AnswerType.RichText,
        content
      })
    }

    const fileType = getVal(obj, 'fileType', '')
    const fileLink = getVal(obj, 'fileLink', '')
    const typeList: string[] = ['gif', 'png', 'jpeg', 'jpg', 'bmp', 'webp']
    if (typeList.includes(fileType)) {
      dataList.push({
        contentType: AnswerType.SinglePic,
        content: fileLink,
        fileType
      })
    } else if (['mp4', 'mp3', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'rar', 'zip', 'tar', 'accdb', 'bmp', 'pub'].includes(fileType)) {
      dataList.push({
        contentType: AnswerType.Attachment,
        content: fileLink,
        fileType
      })
    }
    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.RobotMsg,
      content: dataList,
      showFeedback: obj.satisfactionFlag === 0,
      showManual
    })
  }

  /**
   * 处理会话超时
   */
  sessionTimeOut (question: string) {
    this.initConsult().then(res => {
      this.requestAnswer(question)
    })
  }

  /**
   * 转人工意图转人工
   */
  manualHandle(obj: any, question: string, flag: boolean) {
    if (flag) {
      // 展示时间
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Time,
        content: moment().format('YYYY-MM-DD HH:mm:ss')
      })
      // 展示问题
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.UserMsg,
        content: question
      })
    }

    this.manulBtn.toHuman(question, () => {
      // 成功记录日志
      Common.recordTurnToSeat({
        talkId: this.talkId,
        userId: this.userId,
        isLogin: '2',
        channelId: this.channelId,
        operationType: 1,
        answerStamp: obj.data.answerStamp
      }).catch(err => {
        DLog.error(err)
      })
    })
  }

  rejectToManual(obj: any, question: string, flag: boolean) {
    if (flag) {
      // 展示时间
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.Time,
        content: moment().format('YYYY-MM-DD HH:mm:ss')
      })
      // 展示问题
      this.messageList.push({
        uuid: uuidv4(),
        type: MsgType.UserMsg,
        content: question
      })
    }

    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.RejectManual,
      content: ''
    })
  }

  previewImg (src: string) {
    this.imgPreview.show(src)
  }

  sendVoice(obj: any) {
    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.UserVoice,
      content: {
        text: obj.content,
        blob: obj.blob,
        time: obj.time
      }
    })

    if (!isEmpty(obj.content)) {
      this.requestAnswer(obj.content, false)
    }
  }

  sendImage(oldBase64: string,base64: string) {
    this.messageList.push({
      uuid: uuidv4(),
      type: MsgType.UserImg,
      content: oldBase64
    })
    this.manulBtn.sendImage(base64)
  }

  onChatTypeChange(type: ChatType) {
    ChatModule.setChatType(type)
  }

  toggleEmoji() {
    this.emojiVisible = !this.emojiVisible
  }

  onHide() {
    this.emojiVisible = false
  }

  onSubmit(obj: any) {
    this.manulBtn.sendSatisfy(obj, () => {
      // 人人结束逻辑
      this.manulBtn.releaseChat()
      ChatModule.setChatType(ChatType.ToRobot)
      this.endChat()
    })
  }
}
